import React from 'react';
import PropTypes from 'prop-types';
import { Box, Table, TableBody, TableHead, styled } from '@mui/material';

const MaxHeightTableContainer = styled(Box, { shouldForwardProp: prop => !['layout', 'maxHeight'].includes(prop) })(
  ({ theme, layout, maxHeight }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    '& table': {
      tableLayout: layout
    },
    '& .max-height-body-container': {
      overflow: 'auto',
      maxHeight: typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight
    }
  })
);

function MaxHeightTableFn({ maxHeight, layout = 'fixed', children }) {
  return (
    <MaxHeightTableContainer maxHeight={maxHeight} layout={layout}>
      {children}
    </MaxHeightTableContainer>
  );
}

MaxHeightTableFn.propTypes = {
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  layout: PropTypes.oneOf(['auto', 'fixed', 'inherit', 'initial', 'revert', 'revert-layer', 'unset']),
  children: PropTypes.node
};

function HeadFn({ children }) {
  return (
    <Table>
      <TableHead>{children}</TableHead>
    </Table>
  );
}

HeadFn.propTypes = {
  children: PropTypes.node
};

function BodyFn({ children }) {
  return (
    <Box className='max-height-body-container'>
      <Table>
        <TableBody>{children}</TableBody>
      </Table>
    </Box>
  );
}

BodyFn.propTypes = {
  children: PropTypes.node
};

export default Object.assign(MaxHeightTableFn, {
  Head: HeadFn,
  Body: BodyFn
});
